import "core-js/modules/es.error.cause.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-65ed670c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  class: "cms-flex--between mg-b--15"
};
const _hoisted_3 = {
  class: "cms-page-title"
};
const _hoisted_4 = {
  class: "cms-card-block"
};
const _hoisted_5 = {
  class: "cms-module-title mg-t--25 mg-b--25"
};
const _hoisted_6 = {
  class: "cms-module-title mg-t--25 mg-b--25"
};
const _hoisted_7 = {
  key: 1,
  class: "cms-module-title mg-t--25 mg-b--25"
};
const _hoisted_8 = {
  class: "upload-warp"
};
const _hoisted_9 = {
  key: 2,
  class: "cms-module-title mg-t--25 mg-b--25"
};
const _hoisted_10 = {
  class: "upload-warp"
};
const _hoisted_11 = {
  key: 3,
  class: "cms-module-title mg-t--25 mg-b--25"
};
const _hoisted_12 = {
  class: "upload-warp"
};
const _hoisted_13 = {
  class: "flex-j-center"
};
const _hoisted_14 = ["src", "alt"];
const _hoisted_15 = {
  key: 4,
  class: "check-btn"
};
const _hoisted_16 = {
  class: "result"
};
const _hoisted_17 = {
  class: "blod"
};
const _hoisted_18 = {
  key: 0
};
const _hoisted_19 = {
  class: ""
};
const _hoisted_20 = {
  class: "result"
};
const _hoisted_21 = {
  class: "blod"
};
const _hoisted_22 = {
  key: 0
};
const _hoisted_23 = {
  key: 0
};
const _hoisted_24 = {
  key: 1
};
const _hoisted_25 = {
  style: {
    "color": "#222930",
    "font-size": "16px",
    "margin-bottom": "20px"
  }
};
const _hoisted_26 = {
  key: 2
};
const _hoisted_27 = {
  style: {
    "color": "#222930",
    "font-size": "16px",
    "margin-bottom": "20px"
  }
};
import Buttons from '@/components/Buttons/index.vue';
import FormGroup from '../components/FormGroup/index.vue';
import ImageItem from '../../Components/ImageItem/index.vue';
import { useI18n } from 'vue-i18n';
import { elMessage } from '@/utils';
import { clearData } from '@/utils/tools';
import { useCommon } from '@/store/useCommon';
import { AUDIT_STATUS_NEW, RELEASE_STATUS_NEW } from '@/assets/config/dicts';
import { getProgramInfoApi, getAgentRelationCategorysApi, auditStatusApi, getProgramSetApi, getCloudDiskOptionsApi } from '@/api/vodNew';
import { useVodLanguages } from '@/utils/cacheData';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    detailInfo: {
      type: Object,
      default: () => {}
    },
    // 显示审核状态/上线状态  true 审核状态 false 上线状态
    showAuditStatus: {
      type: Boolean,
      default: true
    },
    headerTitle: {
      type: String,
      default: '审核'
    },
    cid: {
      type: [String, Number],
      default: undefined
    }
  },
  emits: ['update:modelValue', 'update-list', 'to-edit'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const resonFormRef = ref();
    const cloudDiskOptions = ref();
    const PROGTAM_TYPE = {
      movie: t('单片'),
      tv_series: t('剧集')
    };
    const ADULT_TYPE = {
      no: t('否'),
      yes: t('是')
    };
    const languageOptions = ref([]); // 获取所有语言

    const getAllLanguages = async () => {
      const res = await useVodLanguages();
      languageOptions.value = res;
    };

    const validatorReason = (rule, value, callback) => {
      if (value && value.trim() == '') {
        return callback(new Error('输入不能为空'));
      }

      callback();
    };

    const formConfig = reactive({
      formList: [[{
        label: '名称',
        prop: 'name',
        widgetType: 'text'
      }, {
        label: '影片类型',
        prop: 'programType',
        widgetType: 'text',
        formatter: val => PROGTAM_TYPE[val]
      }], [{
        label: '成人内容',
        prop: 'adult',
        widgetType: 'text',
        formatter: val => ADULT_TYPE[val]
      }, {
        label: '关联系列',
        prop: 'videoSeriesIdList',
        widgetType: 'text',
        formatter: val => {
          if (val) {
            let res = [];
            val.forEach(item => {
              programSetList.value.forEach(program => {
                if (program.id == item) {
                  res.push(program.name);
                }
              });
            });
            return res.join();
          }
        }
      }] // [
      //     {
      //         label: '季', prop: 'sequence', widgetType: 'text', required: true,
      //         controller: (value, data, config) => {
      //             return props.detailInfo.programType == 'tv_series';
      //         }
      //     },
      //     {
      //         label: '关联云盘', prop: 'cloudDiskIdList', widgetType: 'text',
      //         formatter: (val) => {
      //             if(val) {
      //                 let res = []
      //                 val.forEach(item => {
      //                     cloudDiskOptions.value.forEach(cloud => {
      //                         if(cloud.id == item) {
      //                             res.push(cloud.username)
      //                         }
      //                     })
      //                 })
      //                 return res.join();
      //             }
      //         }
      //     }
      // ]
      ],
      formData: {
        name: '',
        programType: '',
        adult: '',
        videoSeriesIdList: ''
      }
    });
    const data = reactive({
      imgVisible: false,
      dialogImageUrl: '',
      imgList: [],
      operationList: [{
        src: require('@/assets/imgs/pic_search.png'),
        action: (item, index) => {
          data.dialogImageUrl = item.url ? item.url : item.file[0];
          data.imgVisible = true;
        }
      }],
      infoLoading: false,
      auditStatus: '',
      remark: '',
      anew: false,
      categoryIds: [],
      postData: {
        reason: ''
      },
      checked: false,
      releaseStatus: '',
      offlineReason: ''
    });
    const media = reactive({
      formList: [[{
        label: '信息源ID',
        prop: 'sourceId',
        widgetType: 'text'
      }, {
        label: '名称',
        prop: 'name',
        widgetType: 'text'
      }], [{
        label: '年份',
        prop: 'year',
        widgetType: 'text'
      }, {
        label: '影片时长',
        prop: 'length',
        widgetType: 'text'
      }], [{
        label: '国家',
        prop: 'country',
        widgetType: 'text'
      }, {
        label: '分类属性',
        prop: 'genreList',
        widgetType: 'text',
        formatter: (val, data, config) => {
          if (val && val.length > 0) {
            let formateArr = val.map(item => item.name);
            return formateArr.join(', ');
          }
        }
      }], [{
        label: '上映时间',
        prop: 'releaseDate',
        widgetType: 'text'
      }, {
        label: '预告片',
        prop: 'videoSeriesIdList',
        widgetType: 'text',
        formatter: val => {
          if (val && val.length > 0) {
            return val.join(',');
          }
        }
      }], [{
        label: '评分',
        prop: 'rating',
        widgetType: 'text',
        formatter: (val, data, config) => {
          if (val) {
            return val;
          }
        }
      }, {
        label: '认证',
        prop: 'certification',
        widgetType: 'text'
      }], [{
        label: '导演',
        prop: 'directorList',
        widgetType: 'text',
        colspan: 3,
        formatter: (val, data, config) => {
          if (val && val.length > 0) {
            let formateArr = val.map(item => item.name);
            return formateArr.join(', ');
          }
        }
      }], [{
        label: '演员',
        prop: 'actorList',
        widgetType: 'text',
        colspan: 3,
        formatter: (val, data, config) => {
          if (val && val.length > 0) {
            let formateArr = val.map(item => item.name);
            return formateArr.join(', ');
          }
        }
      }], [{
        label: '描述',
        prop: 'description',
        widgetType: 'text',
        maxlength: 100,
        showWordLimit: true,
        autosize: true,
        colspan: 3
      }]],
      formData: [{
        language: '',
        id: '',
        name: '',
        year: '',
        vodTime: '',
        country: '',
        attribute: '',
        director: '',
        actor: '',
        description: ''
      }]
    });

    const back = () => {
      emit('update:modelValue', false);
      emit('update-list');
    }; // 获取云盘选项


    const getCloudDiskOptions = async () => {
      const {
        code,
        data
      } = await getCloudDiskOptionsApi({
        name: useCommon().userData.name
      });

      if (code == 0) {
        cloudDiskOptions.value = data ? [{
          id: '',
          username: t('不关联')
        }, ...data] : [];
      }
    }; // 获取影片详情


    const getProgramInfoById = async () => {
      try {
        data.infoLoading = true;
        const {
          auditStatus,
          ...params
        } = props.detailInfo;
        const res = await getProgramInfoApi({
          programId: params.id,
          programType: params.programType == 'movie' ? 'movie' : 'tv_series'
        });

        if (res.code == '0') {
          formConfig.formData = res.data;
          data.imgList = res.data.posterList.map(item => {
            return { ...item,
              url: item.imageUrl
            };
          });
          data.auditStatus = res.data.auditStatus;
          data.releaseStatus = res.data.releaseStatus;
          data.remark = res.data.remark;
          data.offlineReason = res.data.offlineReason;
          data.categoryIds = res.data.categoryIdList;
          media.formData = res.data.detailList || [];

          if (res.data.categoryIdList && res.data.categoryIdList.length > 0 && useCommon().userData.permissionKey.indexOf('DC_AT') > -1) {
            getSubCategoryName(res.data.categoryIdList);
          }
        }
      } catch (error) {}

      data.infoLoading = false;
    };

    const programSetList = ref([]); // 获取关联系列

    const getProgramSet = async () => {
      try {
        const cid = props.cid ?? sessionStorage.getItem('currentCid');
        const res = await getProgramSetApi({
          cid
        });

        if (res.code == '0') {
          programSetList.value = res.data;
        }
      } catch (error) {}
    }; // 获取关联分类列表


    const getSubCategoryName = async categoryIds => {
      try {
        const cid = props.cid ?? sessionStorage.getItem('currentCid');
        let params = {
          categoryIds,
          cid: cid // type: '4'

        }; //const res = await getAgentRelationCategoryApi(params) as ResType;

        const res = await getAgentRelationCategorysApi({
          categoryIdList: categoryIds,
          cid
        });

        if (res.code == '0') {
          tableConfig.data = res.data;
        }
      } catch (error) {}
    };

    const tableConfig = reactive({
      data: [],
      isCardBlock: false,
      isShowHeader: false,
      headerButtonsList: [{
        label: '终端审核中',
        type: 'info',
        disabled: true,
        controller: btn => {
          return data.auditStatus == 'terminal_audit';
        },
        func: () => {}
      }, {
        label: '终端审核',
        type: 'success',
        disabled: false,
        func: () => {
          dialogConfig.config.title = '终端审核';
          dialogConfig.action = 'terminal_audit';
          dialogConfig.visible = true;
        },
        controller: btn => {
          return data.auditStatus != 'terminal_audit';
        }
      }, {
        label: '审核通过',
        type: '',
        disabled: false,
        func: () => {
          dialogConfig.config.title = '审核通过';
          dialogConfig.action = 'audited';
          dialogConfig.visible = true;
        },
        controller: btn => {
          btn.disabled = data.auditStatus == 'audited' ? true : false;
          return true;
        }
      }, {
        label: '审核不通过',
        type: 'danger',
        disabled: false,
        func: () => {
          dialogConfig.config.title = '审核不通过';
          dialogConfig.action = 'not_approved';
          dialogConfig.visible = true;
        },
        controller: btn => {
          btn.disabled = data.auditStatus == 'not_approved' ? true : false;
          return true;
        }
      }, {
        label: '编辑影片',
        type: 'warning',
        func: () => {
          emit('update:modelValue', false);
          emit('to-edit', props.detailInfo, {
            pageFrom: 'Check'
          });
        }
      }]
    });
    const dialogConfig = reactive({
      visible: false,
      action: 'not_approved',
      config: {
        title: ''
      },
      confirm: done => {
        if (dialogConfig.action === 'not_approved') {
          resonFormRef.value.validate(valid => {
            if (valid) {
              batchOperation('not_approved', done, data.postData.reason.trim());
            }
          });
        } else if (dialogConfig.action === 'terminal_audit') {
          batchOperation('terminal_audit', done);
        } else if (dialogConfig.action === 'audited') {
          batchOperation('audited', done);
        }
      }
    });
    const columnConfig = reactive({
      columnList: [{
        label: '主品牌名称',
        prop: 'mainAgentName',
        align: 'left'
      }, {
        label: '子品牌名称',
        prop: 'subAgentName',
        align: 'left'
      }, {
        label: '分类名称',
        prop: 'categoryName',
        align: 'left'
      }]
    }); // 重新审核按钮点击事件

    const handleAnew = () => {
      data.anew = true;
    }; // 审核接口调用


    const batchOperation = async (action, done, remark) => {
      try {
        let params = {
          auditStatus: action,
          programIds: [props.detailInfo.id],
          programType: props.detailInfo.programType,
          releaseStatus: data.checked ? 'online' : undefined,
          //ifCheck: data.checked,
          remark
        };
        const res = await auditStatusApi(params);

        if (res.code == '0') {
          elMessage('success', '操作成功');
          data.postData.reason = '';
          data.checked = false;
          data.anew = false;
          dialogConfig.visible = false;
          getProgramInfoById();
          setTimeout(() => {
            done();
          }, 500);
        } else {
          done();
        }
      } catch (error) {
        done();
      }
    };

    watch(() => props.modelValue, val => {
      if (val) {
        getAllLanguages();
        getCloudDiskOptions();
        getProgramSet();
        getProgramInfoById();
      } else {
        clearData(formConfig.formData);
        tableConfig.data = [];
        media.formData = [];
        data.imgList = [];
        data.categoryIds = [];
        data.postData.reason = '';
        data.checked = false;
        data.auditStatus = ''; // 审核状态

        data.remark = '';
        data.anew = false; // 是否重新审核按钮状态

        data.categoryIds = [];
        data.postData = {
          reason: ''
        };
        data.checked = false;
        data.releaseStatus = ''; // 上下线状态

        data.offlineReason = '';
      }
    }, {
      immediate: true,
      deep: true
    });
    watch(() => dialogConfig.visible, val => {
      resonFormRef.value && resonFormRef.value.resetFields();
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_FormItem = _resolveComponent("FormItem");

      const _component_FormTable = _resolveComponent("FormTable");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_checkbox = _resolveComponent("el-checkbox");

      const _component_MDialog = _resolveComponent("MDialog");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock(_Fragment, null, [__props.modelValue ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives((_openBlock(), _createElementBlock("div", null, [_createElementVNode("header", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t(__props.headerTitle)), 1), _createVNode(_component_el_button, {
        class: "cms-op-btn cms-op-btn-main",
        onClick: back
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('返回')), 1)]),
        _: 1
      })]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('基础信息')), 1), _createVNode(_component_FormTable, {
        style: {
          "margin-bottom": "30px"
        },
        col: ['15%', '35%', '15%', '35%']
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.detailInfo.programType == 'movie' ? formConfig.formList.slice(0, 3) : formConfig.formList, item => {
          return _openBlock(), _createBlock(_component_FormItem, {
            "form-item": item,
            "form-data": formConfig.formData
          }, null, 8, ["form-item", "form-data"]);
        }), 256))]),
        _: 1
      }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(media.formData, (item, index) => {
        return _openBlock(), _createElementBlock("div", null, [_createVNode(FormGroup, {
          col: ['25%', '25%', '25%', '25%'],
          "form-list": media.formList,
          "form-data": media.formData[index],
          "show-btn": false,
          languageOptions: languageOptions.value
        }, null, 8, ["form-list", "form-data", "languageOptions"])]);
      }), 256)), _unref(useCommon)().userData.permissionKey.indexOf('DC_AT') > -1 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('关联分类')), 1), _createVNode(_component_common_table, {
        style: {
          "width": "100%"
        },
        "table-config": tableConfig,
        showPagination: false
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": columnConfig.columnList
        }, null, 8, ["column-list"])]),
        _: 1
      }, 8, ["table-config"])], 64)) : _createCommentVNode("", true), data.imgList.filter(f => f.type == 'common').length ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t('通用海报')), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, [_createVNode(ImageItem, {
        imageTitle: "影片封面图",
        "img-list": data.imgList.filter(f => f.type == 'common'),
        "operation-list": data.operationList
      }, null, 8, ["img-list", "operation-list"])]), data.imgList.filter(f => f.type == 'android').length ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t('安卓海报')), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_10, [_createVNode(ImageItem, {
        imageTitle: "影片封面图",
        "img-list": data.imgList.filter(f => f.type == 'android'),
        "operation-list": data.operationList,
        imageSize: "630*900px"
      }, null, 8, ["img-list", "operation-list"])]), data.imgList.filter(f => f.type == 'horizontal').length ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t('横版海报')), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_12, [_createVNode(ImageItem, {
        imageTitle: "影片封面图",
        "img-list": data.imgList.filter(f => f.type == 'horizontal'),
        "operation-list": data.operationList,
        imageStyle: "width: 414px;height: 222px",
        imageSize: "1030*580px"
      }, null, 8, ["img-list", "operation-list"])]), _createVNode(_component_el_dialog, {
        closeOnClickModal: false,
        title: _ctx.$t('预览'),
        modelValue: data.imgVisible,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.imgVisible = $event)
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", null, [_createElementVNode("img", {
          style: {
            "width": "100%",
            "height": "100%"
          },
          src: data.dialogImageUrl,
          alt: _ctx.$t('Preview Image')
        }, null, 8, _hoisted_14)])])]),
        _: 1
      }, 8, ["title", "modelValue"]), (data.auditStatus === 'unaudited' || data.auditStatus === 'terminal_audit' || data.anew) && __props.showAuditStatus ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createVNode(Buttons, {
        class: "header__btns",
        "buttons-list": tableConfig.headerButtonsList
      }, null, 8, ["buttons-list"])])) : _createCommentVNode("", true)]), __props.showAuditStatus ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [__props.showAuditStatus && data.auditStatus !== '' && data.auditStatus !== 'unaudited' && data.auditStatus !== 'terminal_audit' && !data.anew ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "check-result",
        style: _normalizeStyle('background-color:' + (data.auditStatus === 'audited' ? '#f5faf8' : ''))
      }, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('审核结果')) + ":", 1), _createElementVNode("span", {
        class: "error-text",
        style: _normalizeStyle('color:' + (data.auditStatus === 'audited' ? '#3aaf81' : ''))
      }, _toDisplayString(data.auditStatus === 'audited' ? _ctx.$t('已通过审核') : data.auditStatus === 'not_approved' ? _ctx.$t('未通过审核') : _unref(AUDIT_STATUS_NEW)[data.auditStatus]), 5)]), data.auditStatus === 'not_approved' ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('原因')) + ":", 1), _createElementVNode("span", null, _toDisplayString(data.remark), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_19, [_createVNode(_component_el_button, {
        disabled: data.releaseStatus === 'online',
        onClick: handleAnew,
        class: "green-btn cms-op-btn cms-op-btn-main"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('重新审核')), 1)]),
        _: 1
      }, 8, ["disabled"])])], 4)) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), !__props.showAuditStatus ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [data.releaseStatus !== '' && data.releaseStatus !== null && data.releaseStatus !== undefined ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "check-result",
        style: _normalizeStyle('background-color:' + (data.releaseStatus === 'online' || data.releaseStatus === 'not_online' ? '#f5faf8' : ''))
      }, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('上线状态')) + ":", 1), _createElementVNode("span", {
        class: "error-text",
        style: _normalizeStyle('color:' + (data.releaseStatus === 'online' || data.releaseStatus === 'not_online' ? '#3aaf81' : ''))
      }, _toDisplayString(_unref(RELEASE_STATUS_NEW)[data.releaseStatus]), 5)]), data.releaseStatus === 'offline' && data.offlineReason !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('原因')) + ":", 1), _createElementVNode("span", null, _toDisplayString(data.offlineReason), 1)])) : _createCommentVNode("", true)])], 4)) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)])), [[_directive_loading, data.infoLoading]])])) : _createCommentVNode("", true), _createVNode(_component_MDialog, {
        autoLoading: "",
        modelValue: dialogConfig.visible,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => dialogConfig.visible = $event),
        nativeConfig: {
          width: '25%',
          top: '20vw'
        },
        dialogConfig: dialogConfig.config,
        onOnConfirm: dialogConfig.confirm
      }, {
        default: _withCtx(() => [dialogConfig.action === 'not_approved' ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createVNode(_component_el_form, {
          model: data.postData,
          ref_key: "resonFormRef",
          ref: resonFormRef
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "reason",
            rules: [{
              validator: validatorReason,
              trigger: 'blur'
            }, {
              max: 100,
              message: _ctx.$t('限制字符数量', {
                num: '100'
              }),
              trigger: 'blur'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              style: {
                "width": "100%"
              },
              placeholder: _ctx.$t('请输入审核不通过原因'),
              maxlength: 100,
              modelValue: data.postData.reason,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => data.postData.reason = $event),
              "show-word-limit": "",
              type: "textarea"
            }, null, 8, ["placeholder", "modelValue"])]),
            _: 1
          }, 8, ["rules"])]),
          _: 1
        }, 8, ["model"])])) : _createCommentVNode("", true), dialogConfig.action === 'audited' ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('确认影片通过审核？')), 1), _createVNode(_component_el_checkbox, {
          modelValue: data.checked,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => data.checked = $event),
          label: _unref(t)('是否直接上线影片'),
          size: "large"
        }, null, 8, ["modelValue", "label"])])) : _createCommentVNode("", true), dialogConfig.action === 'terminal_audit' ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('确认将影片终端审核？')), 1)])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue", "dialogConfig", "onOnConfirm"])], 64);
    };
  }

});